<template>
  <pl-dialog
    title="Change Avatar"
    size="lg"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div
      class="bg-gray-100 border-b mb-8 border-solid border-gray-200 px-7 py-4 flex items-center justify-between"
    >
      <div class="flex items-center space-x-5 text-blueGray-600">
        <div>
          <button class="rounded-full bg-gray-200">
            <i class="fa-solid fa-circle-info p-2 text-blueGray-600"></i>
          </button>
        </div>
        <div class="relative">
          <span class="block"
            >Pick one avatar from the list below or upload your own image.</span
          >
          <div>
            Allowed types: jpeg, png, gif;
            <span class="text-red-500">Size limit: 2MB.</span>
          </div>
        </div>
      </div>
      <div>
        <button
          :disabled="is_uploading"
          class="px-5 py-2 rounded cursor-pointer bg-blueGray-600 text-white disabled:opacity-50"
          @click.prevent="showFilePicker"
        >
          {{ is_uploading ? 'Uploading...' : 'Upload Image' }}
        </button>
        <input
          ref="filepicker"
          type="file"
          style="display: none"
          accept="image/x-png,image/gif,image/jpeg,image/webp"
          @change="validateFile($event)"
        />
      </div>
    </div>
    <div class="flex flex-col h-full overflow-y-auto px-7 pb-4">
      <div class="flex-grow w-full">
        <div
          class="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-11 gap-1 border border-solid border-gray-200 rounded px-5 bg-gray-50 py-5"
        >
          <div v-for="(avatar, index) in galleryList" :key="index">
            <img
              :src="avatar.pathLong"
              :class="{
                'border-2 border-solid border-pinky': avatarSelected === avatar,
              }"
              class="h-16 w-16 rounded-full border-2 p-1 border-solid border-gray-200 cursor-pointer"
              @click="selectedAvatar(avatar)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mx-7 my-6">
      <div class="flex justify-between">
        <div class="flex items-center">
          <span class="mr-3 text-xs text-gray-500"> Preview: </span>
          <img
            v-show="avatarSelected && avatarSelected.pathLong && !is_uploading"
            :src="avatarSelected.pathLong"
            class="h-12 w-12 rounded-full border-2 p-1 border-solid border-gray-200 cursor-pointer"
          />
          <div v-if="is_uploading" class="h-16 w-16 flex items-center">
            <pl-spinner class="x1" />
          </div>
        </div>
        <div class="flex items-center space-x-2">
          <button
            @click="$emit('close')"
            class="bg-gray-100 border border-solid border-gray-200 px-5 py-2 text-blueGray-600 rounded"
          >
            Cancel
          </button>
          <button
            @click="saveAvatar()"
            :disabled="is_uploading"
            class="bg-primary border font-medium border-solid border-primary px-5 py-2 text-white rounded"
          >
            Save and Close
          </button>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import updateUser from 'services/account/updateUser';
  import { EventBus } from 'utils/event-bus';
  import uploadFile from 'services/account/uploadFile';
  import changeAvatar from 'services/account/changeAvatar';
  import { encodeImageUrl } from 'utils/encodeImage';
  export default {
    data() {
      return {
        avatarSelected: {
          pathLong: null,
          pathShort: null,
        },
        gallery: [],
        userChooseAnAvatar: false,
        is_uploading: false,
        fileResponse: null,
      };
    },
    computed: {
      ...mapGetters(['getProfile']),
      galleryList() {
        return this.gallery;
      },
    },
    mounted() {
      this.importAllAvatars(
        require.context('../../../../static/avatars', false, /\.png$/)
      );
      this.avatarSelected.pathLong = this.getProfile.avatar_url;
    },
    methods: {
      encodeImageURI(image_url) {
        return encodeImageUrl(image_url);
      },
      importAllAvatars(r) {
        r.keys().forEach((key) => {
          if (!r(key).includes('avatar')) {
            this.gallery.push({ pathLong: r(key), pathShort: key });
          }
        });
        this.setAvatarSelectedOnInit();
      },
      setAvatarSelectedOnInit() {
        this.gallery.forEach((element) => {
          const nameOfAvatar = element.pathShort.replace('./', '');
          const auxArray = this.getProfile.avatar_url.split('/');
          if (
            this.getProfile &&
            this.getProfile.avatar_url &&
            nameOfAvatar === auxArray[auxArray.length - 1]
          ) {
            this.avatarSelected = element;
          }
        });
      },
      selectedAvatar(avatar) {
        this.avatarSelected = avatar;
        this.userChooseAnAvatar = true;
        this.fileResponse = null;
      },
      saveAvatar() {
        if (
          this.userChooseAnAvatar ||
          (this.fileResponse && this.fileResponse.data)
        ) {
          const user_payload = {};
          if (this.fileResponse && this.fileResponse.data) {
            changeAvatar({
              avatar_path: `/files/${this.fileResponse.data.key}`,
              id: this.getProfile.id,
            }).then(() => {
              const toast = {
                type: 'Success',
                message: 'Avatar changed with success!',
                time: 5000,
              };
              EventBus.$emit('createToast', toast);
              this.$emit('close');
              this.updateRT();
            });
          } else {
            const avatarPath = this.avatarSelected.pathShort.replace('./', '');
            user_payload.avatar_url = `/static/avatars/${avatarPath}`;
            this.updateUserProfile(user_payload);
            const toast = {
              type: 'Success',
              message: 'Avatar changed with success!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          }
        } else {
          this.$emit('close');
        }
      },
      updateUserProfile(user_payload) {
        return updateUser(this.getProfile.id, user_payload)
          .then((res) => {
            this.$store.dispatch('setAccount', res.data);
            this.updateRT();
            this.$emit('close');
          })
          .catch((e) => {
            console.error(e);
            this.$emit('close');
          });
      },
      updateRT() {
        if (this.getCurrentRT && this.getCurrentRT.id) {
          this.$store.dispatch('fetchRoundtable', this.getCurrentRT.id);
        }
      },
      showFilePicker() {
        // simulate a click on the file input
        this.$refs.filepicker.click();
      },
      validateFile(event) {
        const file = event.target.files[0];
        if (file.size > 1000000) {
          const toast = {
            type: 'Error',
            message: 'Invalid file size. (Max. 1MB)!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          return;
        }

        if (
          file.type !== 'image/png' &&
          file.type !== 'image/jpeg' &&
          file.type !== 'image/webp' &&
          file.type !== 'image/gif'
        ) {
          const toast = {
            type: 'Error',
            message: 'Invalid file. (Accepted .jpeg, .png, .gif, .webp)',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          return;
        }
        this.startUpload(file);
      },
      startUpload(file) {
        this.avatarSelected = {};
        this.is_uploading = true;
        uploadFile([file])
          .then((response) => {
            this.fileResponse = response;
            this.userChooseAnAvatar = false;
            setTimeout(() => {
              this.is_uploading = false;
            }, 500);
            const path =
              `${response.config.baseURL}` +
              `${response.config.url}` +
              '/' +
              `${response.data.key}`;
            this.avatarSelected.pathLong = path;
            // update profile to include the newly uploaded image URL
            /* return changeAvatar({
            avatar_path: `/files/${response.data.key}`,
            id: this.getProfile.id,
          }); */
          })
          .catch((err) => {
            this.is_uploading = false;
            console.error(err);
          });
      },
    },
  };
</script>

<style scoped lang="stylus">
  .body-height
    height: calc(80vh - 150px)
    overflow: auto

  .outline-border
    outline: 3px solid black

  .bg-color
    background-color: #7f89a1
</style>



// WEBPACK FOOTER //
// chooseAvatar.vue?812e6ee2